import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "b",
  "strong",
  "i",
  "em",
  "u",
  "s",
  "a",
  "ul",
  "ol",
  "li",
  "p",
  "br",
  "img",
];

const ALLOWED_ATTR = ["href", "target", "rel", "src", "alt", "data-anexo-id"];

function ehParagrafoVazio(el: Element): boolean {
  return (
    el.tagName === "P" &&
    !el.querySelector("img") &&
    !el.textContent?.trim()
  );
}

// O Quill deixa um <p><br></p> sobrando quando o usuário termina a mensagem
// com uma linha em branco, o que aparece como um espaço vazio embaixo da bolha.
function removerParagrafosVaziosNasPontas(html: string): string {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const { body } = doc;
  while (body.lastElementChild && ehParagrafoVazio(body.lastElementChild)) {
    body.lastElementChild.remove();
  }
  while (body.firstElementChild && ehParagrafoVazio(body.firstElementChild)) {
    body.firstElementChild.remove();
  }
  return body.innerHTML;
}

export function sanitizarCorpo(html: string): string {
  if (!html) return "";
  const limpo = DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
  return removerParagrafosVaziosNasPontas(limpo);
}

export function textoPlano(html: string): string {
  return html.replace(/<[^>]*>/g, "").trim();
}
